import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import {
  FF_ORDER_HISTORY_INTERACTION_GA_EVENTS,
  FF_PDP_LINK_CLICK_ON_ORDERS_HISTORY_GA_TRACKING
} from '~app/modules/account/modules/orders-history/constants/orders-history-feature-flags';
import { 
  OrderHistoryApplicationEvent,
  OrderHistoryPDPLinkApplicationEvent 
} from '~shared/modules/application-event/models';

@Injectable({
  providedIn: 'root'
})
export class OrderHistoryGaTrackingService {
  constructor(private featureFlagSrv: ActiveFeaturesConfigcatService,
    private applicationEventService: ApplicationEventService) {
  }

  gaTrackingPDPLinkClickedEvent(productName: string) {
    this.featureFlagSrv.isFeatureEnabled(FF_PDP_LINK_CLICK_ON_ORDERS_HISTORY_GA_TRACKING)
      .pipe(
        filter((isGaTrackingEnabled) => isGaTrackingEnabled),
        take(1)
      )
      .subscribe(() => {
        this.applicationEventService.publish(
          new OrderHistoryPDPLinkApplicationEvent(productName));
      });
  }

  gaTrackingOrderHisotryInteractionsEvent(event: string, action: string, label: string) {
    this.featureFlagSrv.isFeatureEnabled(FF_ORDER_HISTORY_INTERACTION_GA_EVENTS)
      .pipe(
        filter((isGaTrackingEnabled) => isGaTrackingEnabled),
        take(1)
      )
      .subscribe(() => {
        this.applicationEventService.publish(
          new OrderHistoryApplicationEvent({
            event,
            action,
            label
          }));
      });
  }
}
